import { Alert, AlertProps } from '@mui/material';
import { usePhrase } from '@/hooks/general/usePhrase/usePhrase';

interface SuccessAlertProps extends AlertProps {
    id: string;
    phraseId?: number;
}

export const SuccessAlert = ({ id, phraseId, ...other }: SuccessAlertProps) => {
    const { t } = usePhrase();
    return (
        <>
            {phraseId && (
                <Alert severity="success" id={id} {...other}>
                    {t(phraseId)}
                </Alert>
            )}
        </>
    );
};
